<template>
  <el-form-item label="左边距(像素)">
    <el-slider v-model="prop.gridX" :max="400"></el-slider>
  </el-form-item>
  <el-form-item label="顶边距(像素)">
    <el-slider v-model="prop.gridY" :max="400"></el-slider>
  </el-form-item>
  <el-form-item label="右边距(像素)">
    <el-slider v-model="prop.gridX2" :max="400"></el-slider>
  </el-form-item>
  <el-form-item label="底边距(像素)">
    <el-slider v-model="prop.gridY2" :max="400"></el-slider>
  </el-form-item>
</template>
<script setup>
import { dicOption } from "@/option/config";

let props = defineProps({
  prop: {},
});
</script>
<style scoped>
</style>